import React, { useEffect, useState } from "react"
import { Field } from "formik";
import AsyncSelect from "react-select/async"
import styled from "styled-components"
import { apiGetZoteroItemsByCritere } from "../api";

const Formulaire = styled.div`
background-color: darkgrey;
border: 2px solid #e2702c;
float:left;
`

const Champ = styled.div`
margin:0px;
padding: 10px;
float left;
width:80%;
`

const Meta = styled.div`
padding: 10px 0px;
width:100%;
`
const Biblio = styled.div`
margin: 15px;
padding: 10px;
background-color: lightgrey;
float: left;
width:80%;
`

const Label = styled.div`
min-width: 150px;
`

const BiblioZotero = styled(AsyncSelect)`
margin: 10px;
max-width: 500px;
display: block;
`

const initialiseOption = (element) => {
  //console.log(element)
  const valeur = {
    uri: element.uri,
    label: element.label
  }
  const retour = {
    value: valeur,
    label: element.label
  }
  return retour
}

const construitOptionZotero = (element) => {
  //console.log(element)
  const retour = {
    value: {
      uri: element.data.key,
      label: `${element.data.title} (${element.meta.creatorSummary})`
    },
    label:`${element.data.title} (${element.meta.creatorSummary})`
  }
  return retour
}

const valeurs = (tableau) => {
  if ( ! tableau) {
    return []
  }
  return (tableau.map(element => construitOptionZotero(element)))
}

const creeRefBiblio = (valeurChaine) => {
  if ( typeof valeurChaine === "object" || valeurChaine === undefined) {
    return []
  }
  return(JSON.parse(valeurChaine))
}


//Champ texte avec le critere de recherche
//champ div avec la référence visuelle et l'idZotero à sauvegarder
//stockage d'un tableau de référence avec
// uri, label, page,
const ElementFormBiblioAvecChamps = (params) => {

  const {nom, initialValues, handleChange} = params
  const [mesReferencesBiblio, setMesReferencesBiblio] = useState(creeRefBiblio(initialValues))

  const [maValeurZotero, setMaValeurZotero] = useState({})
  const [page, setPage] = useState('')
  const [numero, setNumero] = useState('')
  const [planche, setPlanche] = useState('')
  const [figure, setFigure] = useState( '')

  //console.log(mesReferencesBiblio)

  useEffect(()=>{

  },[initialValues, maValeurZotero, page, numero, planche, figure])

  const handleModifierBiblio = (event) => {
    //parcours du tableau et suppression
    console.log("Référence biblio à modifier")
    const uri = event.target.value
    console.log(uri)
    let refAModifier = {}
    for(const refCourante of mesReferencesBiblio){
      if (refCourante.uri === uri){
         refAModifier = refCourante
         break
      }
    }
    console.log(refAModifier)
    setMaValeurZotero(
      {
        uri: refAModifier.uri,
        label: refAModifier.label
      }
    )

    setPage(refAModifier.page ? refAModifier.page : '' )
    setNumero(refAModifier.numero ? refAModifier.numero : '')
    setPlanche(refAModifier.planche ? refAModifier.planche : '')
    setFigure(refAModifier.figure ? refAModifier.figure : '')
   }

   const handleSupprimerBiblio = (event) => {
    const uri = event.target.value
    let nouvellesRef = []
    for(const refCourante of mesReferencesBiblio){
      if (refCourante.uri === uri){
        continue
      } else {
        nouvellesRef.push(refCourante)
      }
    }
    setMesReferencesBiblio(nouvellesRef)
    handleChange(nouvellesRef)
   }


  const afficheBiblio = (ref_biblio) => {
    const urlZotero = `https://www.zotero.org/groups/1843959/igls/items/${ref_biblio.uri}`
    return (<Meta key={`biblio_${ref_biblio.uri}`}>
      <a key={ref_biblio.uri} href={urlZotero} target= "_blank" rel="noreferrer noopener">{ref_biblio.label}</a>
      { ref_biblio.page ? <span>Page {ref_biblio.page} </span> : null}
      { ref_biblio.numero ? <span>Numéro {ref_biblio.numero} </span> : null}
      { ref_biblio.planche ? <span>Planche {ref_biblio.planche} </span> : null}
      { ref_biblio.figure ? <span>Figure {ref_biblio.figure} </span> : null}
        <button type="button" onClick={handleModifierBiblio} value={ref_biblio.uri}>Modifier</button>
        <button type="button" onClick={handleSupprimerBiblio} value={ref_biblio.uri}>Supprimer</button>
      </Meta>)
  }

  const afficheBiblioInitiales = () => {
    const titre = "Références présentes :"
    const aAfficher = <><Meta>{titre}</Meta>{mesReferencesBiblio.map( element => afficheBiblio(element))}</>
    return aAfficher
  }


  const loadOptions = async (critere, callback) => {
    //console.log(critere )
    const retour = await apiGetZoteroItemsByCritere(critere)
    let mesOptions = []
    mesOptions = valeurs(retour.reponse)
    callback(mesOptions)
   }


  const handleChangeBiblio = (monOption) => {
    setMaValeurZotero(monOption.value)
  }


  const handleChangePage = (event) => {
    setPage(event.target.value)
  }

  const handleChangeNumero = (event) => {
    setNumero(event.target.value)
  }

  const handleChangePlanche = (event) => {
    setPlanche(event.target.value)
  }

  const handleChangeFigure = (event) => {
    setFigure(event.target.value)
  }


  const handleClick = () => {

    //cas du submit sans saisie
    if ( ! maValeurZotero.uri || typeof maValeurZotero.uri !== 'string'){
      return
    }

    const tempo = {}
    tempo.uri = maValeurZotero.uri
    tempo.label = maValeurZotero.label
    tempo.page = page
    tempo.numero = numero
    tempo.planche = planche
    tempo.figure = figure

    let nouvellesRef = []
    let trouve = false
    for(const refCourante of mesReferencesBiblio){
      if (refCourante.uri === tempo.uri){
        //modification
        nouvellesRef.push(tempo)
        trouve = true
      } else {
        nouvellesRef.push(refCourante)
      }
    }
    if (! trouve){
      nouvellesRef.push(tempo)
    }
    setMesReferencesBiblio(nouvellesRef)
    //console.log(nouvellesRef)
    setMaValeurZotero({})
    setPage('')
    setNumero('')
    setPlanche('')
    setFigure('')
    handleChange(nouvellesRef)
  }

  //creation de l'element select multiple
  return (
    <Biblio id="referencesBiblio">
     {afficheBiblioInitiales()}
      <Formulaire>
      <Champ>
        <Label>{nom}</Label>
        <BiblioZotero
          name={nom}
          value={initialiseOption(maValeurZotero)}
          defaultValue={initialiseOption(maValeurZotero)}
          placeholder={"Recherche d'une référence biblio"}
          onChange={handleChangeBiblio}
          loadOptions={loadOptions}
        />
      </Champ>
      <Champ>
        <Label>Page</Label>
        <Field name="page" type="text" className="form-control" size="40" onChange={handleChangePage} value={page}/>
      </Champ>
      <Champ>
        <Label>Numéro</Label>
        <Field name="numero" type="text" className="form-control" size="40" onChange={handleChangeNumero} value={numero}/>
      </Champ>
      <Champ>
        <Label>Planche</Label>
        <Field name="planche" type="text" className="form-control" size="40" onChange={handleChangePlanche} value={planche}/>
      </Champ>
      <Champ>
        <Label>Figure</Label>
        <Field name="figure" type="text" className="form-control" size="40" onChange={handleChangeFigure} value={figure}/>
      </Champ>
      <Champ>
            <button type="button" onClick={handleClick}>Valider</button>
            <br/><i>(ne pas oublier de modifier l'inscription si nécessaire)</i>
      </Champ>
      </Formulaire>
    </Biblio>
  )

}
export default ElementFormBiblioAvecChamps